class FontStyleManager {
    rawDocument?: Document;
    styleElement?: HTMLStyleElement;

    insertCustomFontStyle = (root: ShadowRoot) => {
        this.rawDocument = root.ownerDocument;
        if (this.rawDocument && !this.styleElement) {
            this.styleElement = this.rawDocument.createElement('style');
            this.styleElement.textContent = `
            @font-face {
                font-family: 'D-DIN-PRO';
                src: url('https://gd-file.gaodun.com/fonts/D-DIN-PRO/D-DIN-PRO-600-SemiBold.woff2') format('woff2'),
                    url('https://gd-file.gaodun.com/fonts/D-DIN-PRO/D-DIN-PRO-600-SemiBold.woff') format('woff');
                font-weight: 600;
                font-display: swap;
                font-style: normal;
            }
            `;
            this.rawDocument.head.appendChild(this.styleElement);
        }
    };

    removeCustomFontStyle = () => {
        if (this.rawDocument && this.styleElement) {
            // 检查 styleElement 是否在 rawDocument.head 中
            if (this.rawDocument.head.contains(this.styleElement)) {
                this.rawDocument.head.removeChild(this.styleElement);
                this.styleElement = undefined;
            } else {
                console.warn('styleElement 不存在于 rawDocument.head 中');
            }
        }
    };
}

export default new FontStyleManager();
